'use client';
import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import CatalogueFilters from './components/CatalogueFilters';
import CatalogueGrid from './components/CatalogueGrid';
import { ArrowRight } from 'lucide-react';

export default function CourseCataloguePage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Public Navigation */}
      <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-md border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link href="/" className="flex items-center gap-2.5">
            <AppLogo size={32} />
            <span className="font-bold text-lg text-foreground tracking-tight">EugeneTechRN</span>
          </Link>
          <nav className="hidden md:flex items-center gap-6">
            <Link href="/course-catalogue" className="text-sm font-medium text-foreground transition-colors">Browse Courses</Link>
            <Link href="/community-hub" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Community</Link>
          </nav>
          <div className="flex items-center gap-3">
            <Link
              href="/sign-up-login-screen"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors hidden sm:block"
            >
              Sign In
            </Link>
            <Link
              href="/sign-up-login-screen"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl bg-primary text-primary-foreground text-sm font-semibold hover:opacity-90 transition-opacity"
            >
              Get Started
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </header>

      {/* Page Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="space-y-5">
          <div>
            <h1 className="text-2xl font-bold text-foreground">Course Catalogue</h1>
            <p className="text-muted-foreground text-sm mt-1">
              Browse 200+ courses across AI, Data Science, Health Informatics, and Coding for Kids
            </p>
          </div>
          <div className="flex gap-6">
            <CatalogueFilters />
            <CatalogueGrid />
          </div>
        </div>
      </main>
    </div>
  );
}